import React, { useState, useEffect } from "react";
import LoginHeader from "./components/LoginHeader.js";
import AADHeader from "./components/AADHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import AdvisorChat from "./components/Advisor/AdvisorChat";
import NoAccess from "./components/NoAccess";
import { appInsights } from "./AppInsights";

export default function AdvisorPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  // The Advisor's server guard only accepts verified Microsoft (Entra) sign-ins;
  // for password sessions, show a clear panel instead of a chat that rejects
  // every question. The sidebar hides the item for them too — this covers
  // direct navigation to /advisor.
  const isAAD = localStorage.getItem("loginType") === "AAD";

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  useEffect(() => {
    appInsights.trackPageView();
    const handleResize = () => setIsSidebarOpen(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="Advisor" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="Advisor" />;
  };

  if (!isAAD) {
    return <NoAccess message="The Advisor is available for Microsoft (organization) sign-ins. Sign out and use 'Sign in with Microsoft' to chat with it." />;
  }

  return (
    <div id="wrapper">
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div style={{ height: "calc(100vh - 80px)", maxWidth: "900px", margin: "0 auto", padding: "16px" }}>
          <div style={{ height: "100%", border: "1px solid #E5E5E5", borderRadius: "8px", overflow: "hidden" }}>
            <AdvisorChat />
          </div>
        </div>
      </div>
    </div>
  );
}
